import { render, staticRenderFns } from "./EntityTypeSettings.vue?vue&type=template&id=7a26207a&scoped=true"
import script from "./EntityTypeSettings.vue?vue&type=script&lang=js"
export * from "./EntityTypeSettings.vue?vue&type=script&lang=js"
import style0 from "./EntityTypeSettings.vue?vue&type=style&index=0&id=7a26207a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a26207a",
  null
  
)

export default component.exports